/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlResolutionRequestStatus } from './ControlResolutionRequestStatus';
import {
    ControlResolutionRequestStatusFromJSON,
    ControlResolutionRequestStatusFromJSONTyped,
    ControlResolutionRequestStatusToJSON,
} from './ControlResolutionRequestStatus';
import type { ControlResolutionTypes } from './ControlResolutionTypes';
import {
    ControlResolutionTypesFromJSON,
    ControlResolutionTypesFromJSONTyped,
    ControlResolutionTypesToJSON,
} from './ControlResolutionTypes';

/**
 * 
 * @export
 * @interface ControlEntityFindingsAssetsResult
 */
export interface ControlEntityFindingsAssetsResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    port?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityFindingsAssetsResult
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    found?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityFindingsAssetsResult
     */
    other_assets?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    first_detected?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    score_category?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    datapoint?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ControlEntityFindingsAssetsResult
     */
    evidences?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityFindingsAssetsResult
     */
    risk_score?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    finding_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    process_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    monit_type?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityFindingsAssetsResult
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    as_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    as_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    as_class?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    isp?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAssetsResult
     */
    removal_status?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ControlEntityFindingsAssetsResult
     */
    matches?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<ControlResolutionTypes>}
     * @memberof ControlEntityFindingsAssetsResult
     */
    resolution_types?: Array<ControlResolutionTypes>;
    /**
     * 
     * @type {ControlResolutionRequestStatus}
     * @memberof ControlEntityFindingsAssetsResult
     */
    resolution_status?: ControlResolutionRequestStatus;
}

/**
 * Check if a given object implements the ControlEntityFindingsAssetsResult interface.
 */
export function instanceOfControlEntityFindingsAssetsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityFindingsAssetsResultFromJSON(json: any): ControlEntityFindingsAssetsResult {
    return ControlEntityFindingsAssetsResultFromJSONTyped(json, false);
}

export function ControlEntityFindingsAssetsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityFindingsAssetsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'other_assets': !exists(json, 'other_assets') ? undefined : json['other_assets'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'first_detected': !exists(json, 'first_detected') ? undefined : json['first_detected'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'score_category': !exists(json, 'score_category') ? undefined : json['score_category'],
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
        'evidences': !exists(json, 'evidences') ? undefined : json['evidences'],
        'risk_score': !exists(json, 'risk_score') ? undefined : json['risk_score'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'finding_id': !exists(json, 'finding_id') ? undefined : json['finding_id'],
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
        'monit_type': !exists(json, 'monit_type') ? undefined : json['monit_type'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'as_number': !exists(json, 'as_number') ? undefined : json['as_number'],
        'as_name': !exists(json, 'as_name') ? undefined : json['as_name'],
        'as_class': !exists(json, 'as_class') ? undefined : json['as_class'],
        'isp': !exists(json, 'isp') ? undefined : json['isp'],
        'removal_status': !exists(json, 'removal_status') ? undefined : json['removal_status'],
        'matches': !exists(json, 'matches') ? undefined : json['matches'],
        'resolution_types': !exists(json, 'resolution_types') ? undefined : ((json['resolution_types'] as Array<any>).map(ControlResolutionTypesFromJSON)),
        'resolution_status': !exists(json, 'resolution_status') ? undefined : ControlResolutionRequestStatusFromJSON(json['resolution_status']),
    };
}

export function ControlEntityFindingsAssetsResultToJSON(value?: ControlEntityFindingsAssetsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'asset': value.asset,
        'source_asset': value.source_asset,
        'port': value.port,
        'shared': value.shared,
        'found': value.found,
        'other_assets': value.other_assets,
        'created': value.created,
        'updated': value.updated,
        'first_detected': value.first_detected,
        'level': value.level,
        'category': value.category,
        'score_category': value.score_category,
        'datapoint': value.datapoint,
        'evidences': value.evidences,
        'risk_score': value.risk_score,
        'status': value.status,
        'finding_id': value.finding_id,
        'process_id': value.process_id,
        'monit_type': value.monit_type,
        'tags': value.tags,
        'source': value.source,
        'as_number': value.as_number,
        'as_name': value.as_name,
        'as_class': value.as_class,
        'isp': value.isp,
        'removal_status': value.removal_status,
        'matches': value.matches,
        'resolution_types': value.resolution_types === undefined ? undefined : ((value.resolution_types as Array<any>).map(ControlResolutionTypesToJSON)),
        'resolution_status': ControlResolutionRequestStatusToJSON(value.resolution_status),
    };
}

